module.exports = __webpack_public_path__ + "img/selected3-min.b8af9183.png";